import { FirebaseRemoteConfig } from '@capacitor-firebase/remote-config'
import { App, AppState } from '@capacitor/app'
import { Dialog } from '@capacitor/dialog'
import { PushNotifications } from '@capacitor/push-notifications'
import { isPlatform } from '@ionic/react'
import { compareVersions } from 'compare-versions'
import { useEffect } from 'react'
import { useNotificaitonRegister } from '../notification'

// 強制アップデートをかけたい
const checkUpdate = async () => {
  if (!isPlatform('capacitor')) return
  // activate
  await FirebaseRemoteConfig.fetchAndActivate()
  await FirebaseRemoteConfig.fetchConfig({
    minimumFetchIntervalInSeconds: 10
  })
  // ios の場合
  if (isPlatform('ios')) {
    const { value: iosStoreUrl } = await FirebaseRemoteConfig.getString({
      key: 'ios_store_url'
    })
    const { value: iosStoreVersion } = await FirebaseRemoteConfig.getString({
      key: 'ios_store_version'
    })
    const info = await App.getInfo()
    const currentVersion = info.version

    const isNeedUpdate = compareVersions(currentVersion, iosStoreVersion) === -1

    console.log({ currentVersion, iosStoreVersion, iosStoreUrl, isNeedUpdate })

    if (isNeedUpdate) {
      await Dialog.alert({
        title: 'お知らせ',
        message: '新しいアプリのアップデートがあります。更新してください'
      })
      window.open(iosStoreUrl, '_blank')
    }
  }
  // android の場合
  if (isPlatform('android')) {
    const { value: androidStoreUrl } = await FirebaseRemoteConfig.getString({
      key: 'android_store_url'
    })
    const { value: androidStoreVersion } = await FirebaseRemoteConfig.getString({
      key: 'android_store_version'
    })
    const info = await App.getInfo()
    const currentVersion = info.version

    const isNeedUpdate = compareVersions(currentVersion, androidStoreVersion) === -1

    console.log({ currentVersion, androidStoreVersion, androidStoreUrl, isNeedUpdate })

    if (isNeedUpdate) {
      await Dialog.alert({
        title: 'お知らせ',
        message: '新しいアプリのアップデートがあります。更新してください'
      })
      window.open(androidStoreUrl, '_blank')
    }
  }
}

export const useRegisterApplicationListner = () => {
  const { handleNotificationRegister } = useNotificaitonRegister()
  // const { user } = useGetMe()
  useEffect(() => {
    App.addListener('appStateChange', async (state: AppState) => {
      // state.isActive contains the active state
      console.log('App state changed. Is active?', state.isActive)
      // @TODO: userの状態を見て、ログインしているときだけ通知登録するようにする
      // if (user?.id && state.isActive) {
      //   handleNotificationRegister()
      //   if (isPlatform('capacitor')) {
      //     try {
      //       await PushNotifications.removeAllDeliveredNotifications()
      //     } catch (error) {
      //       console.warn('Failed to remove notifications:', error)
      //     }
      //   }
      // }

      if (state.isActive) {
        checkUpdate()
      }
    })
    App.addListener('appUrlOpen', (data: any) => {
      console.log('App opened with URL: ' + data.url)
    })
    App.addListener('appRestoredResult', (data: any) => {
      console.log('Restored state:', data)
    })

    return () => {
      App.removeAllListeners()
    }
  }, [handleNotificationRegister /*user*/])

  useEffect(() => {
    checkUpdate()
  }, [])
}

export const useApplication = () => {
  useEffect(() => {
    ;(async () => {
      if (!isPlatform('capacitor')) {
        console.warn('PushNotifications is not available on web platform')
        return
      }

      try {
        await PushNotifications.removeAllDeliveredNotifications()
      } catch (error) {
        console.warn('Failed to remove notifications:', error)
      }
    })()
  }, [])
}
